/**
 * 统一认证改造后的 token 存储。
 * - today_global_token: 全局身份 token，用于调用 auth profile、context
 * - today_token: blog app token，用于调用 blog 业务 API
 * - today_user: { id, username, email?, role }，用于 UI 展示
 */

export const AUTH_KEYS = {
  GLOBAL_TOKEN: 'today_global_token',
  APP_TOKEN: 'today_token',
  USER: 'today_user',
} as const;

/** 业务 API 使用 blog app token（D1 完成后已切换） */
export function getTokenForApi(): string | null {
  return localStorage.getItem(AUTH_KEYS.APP_TOKEN);
}

export function getGlobalToken(): string | null {
  return localStorage.getItem(AUTH_KEYS.GLOBAL_TOKEN);
}

export function getAppToken(): string | null {
  return localStorage.getItem(AUTH_KEYS.APP_TOKEN);
}

export function setAuthSession(globalToken: string, appToken: string, user: { id: number; username: string; email?: string; role: string }) {
  localStorage.setItem(AUTH_KEYS.GLOBAL_TOKEN, globalToken);
  localStorage.setItem(AUTH_KEYS.APP_TOKEN, appToken);
  localStorage.setItem(AUTH_KEYS.USER, JSON.stringify(user));
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_KEYS.GLOBAL_TOKEN);
  localStorage.removeItem(AUTH_KEYS.APP_TOKEN);
  localStorage.removeItem(AUTH_KEYS.USER);
}
